import { render, staticRenderFns } from "./ReportOrderSumsPerSupplierPage.vue?vue&type=template&id=456ec638&scoped=true"
import script from "./ReportOrderSumsPerSupplierPage.vue?vue&type=script&lang=js"
export * from "./ReportOrderSumsPerSupplierPage.vue?vue&type=script&lang=js"
import style0 from "./ReportOrderSumsPerSupplierPage.vue?vue&type=style&index=0&id=456ec638&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456ec638",
  null
  
)

export default component.exports